
import { Component, Vue } from 'vue-property-decorator';
import RoomReserveConfig from './components/roomReserveConfig.vue';
import Confirm from './components/confirm.vue';
import Calendar from '@/components/Calendar/index.vue';
import { getStayRoomListAll } from '@/api/stayRoom';
import { changeStayRoomStatus } from '@/api/stayRoomClose';

@Component({
  components: {
    RoomReserveConfig,
    Calendar,
    Confirm,
  },
})
export default class extends Vue {
  mounted() {
    this.getRoomList();
  }

  private handleDialogOpen() {
    // 다이얼로그가 열리면서 다음 프레임에서 버튼에 포커스를 설정
    this.$nextTick(() => {
      if (this.roomConfigFormVisible) (document.querySelector('.room-reserve-config-form .submit') as HTMLElement).focus(); // 버튼의 ID에 따라 수정
      else if (this.confirmVisible) (document.querySelector('.room-confirm-form .submit') as HTMLElement).focus(); // 버튼의 ID에 따라 수정
    });
  }

  private roomList = [];

  private selectedRoom = {
    roomIdx: '',
    date: '',
    cancelStatus: true,
  }

  private roomConfigFormVisible = false;

  private todayYear = new Date().getFullYear();

  private todayMonth = new Date().getMonth() + 1;

  private changeBtn = false;

  private today = new Date();

  private clickPrevMonth() {
    if (!this.changeBtn) {
      if (this.todayMonth === 1) this.today = new Date(this.today.getFullYear() - 1, this.todayMonth - 1, this.today.getDate());
      else this.today = new Date(this.today.getFullYear(), this.todayMonth - 1, this.today.getDate());
    }
    this.changeCalendar(this.today);
  }

  private clickNextMonth() {
    if (!this.changeBtn) {
      if (this.todayMonth === 11) this.today = new Date(this.today.getFullYear() - 1, this.todayMonth + 1, this.today.getDate());
      else this.today = new Date(this.today.getFullYear(), this.todayMonth + 1, this.today.getDate());
    }
    this.changeCalendar(this.today);
  }

  private changeCalendar(today: any) {
    this.todayYear = today.getFullYear();
    if (this.changeBtn) {
      this.todayMonth = today.getMonth() + 1;
      this.today = new Date(this.today.getFullYear(), this.todayMonth, this.today.getDate());
    } else this.todayMonth = today.getMonth();
    if (this.todayMonth === 0) this.todayMonth = 12;
    this.changeBtn = false;
  }

  private handleRoomConfigVisible() {
    this.roomConfigFormVisible = true;
  }

  private handleChangeStatus(form: any) {
    this.roomConfigFormVisible = false;
    if (this.$refs.calendar) (this.$refs.calendar as any).reloadCalendar();
  }

  private confirmVisible = false;

  private handleConfirmVisible(roomIdx: any, date: any, cancelStatus: boolean) {
    this.selectedRoom.roomIdx = roomIdx;
    this.selectedRoom.date = date;
    this.selectedRoom.cancelStatus = cancelStatus;
    this.confirmVisible = !this.confirmVisible;
  }

  private closeConfirmForm() {
    this.confirmVisible = false;
  }

  private submitConfirmForm() {
    this.confirmVisible = false;
    if (this.$refs.calendar) (this.$refs.calendar as any).reloadCalendar();
  }

  private getRoomList() {
    getStayRoomListAll().then((res) => {
      this.roomList = res.data;
    });
  }

  private handleClickRoom(roomInfo: any) {
    const confirmTitle = roomInfo.closeStatus ? '객실예약 방막기(예약완료)' : '객실예약 방풀기(예약가능)';
    const confirmMessage = roomInfo.closeStatus ? '객실예약을 방막기(예약완료) 하시겠습니까?' : '객실예약을 방풀기(예약가능) 하시겠습니까?';
    if (roomInfo) {
      this.$confirm(`(${roomInfo.roomName} - ${roomInfo.date}) ${confirmMessage}`, confirmTitle, {
        confirmButtonText: confirmTitle,
        cancelButtonText: '닫기',
        type: 'error',
      }).then(() => {
        const formData = {
          roomIdxList: [roomInfo.roomIdx],
          startDate: roomInfo.date,
          endDate: roomInfo.date,
          closeStatus: roomInfo.closeStatus,
        };
        changeStayRoomStatus(formData).then(() => {
          this.$message.success(`성공적으로 ${confirmTitle}되었습니다.`);
          // if (this.$refs.calendar) (this.$refs.calendar as any).changeCalendar(this.today);
          if (this.$refs.calendar) (this.$refs.calendar as any).reloadCalendar();
        });
      });
    }
  }
}
